export const userFeatureFlags = 'user:featureflags';
export const userSocketDetails = 'user:socketdetails';
export const sessionUnlock = 'session:unlock';
export const userDetailsWebCommand = 'user:detailsWeb';
export const accessBlocksList = 'access:blockslist';
export const userRegisterDetails = 'user:registerdetails';
export const userSetLanguage = 'user:setlanguage';
export const userTermsGetNew = 'user:termsgetnew';
export const userTermsAccept = 'user:termsaccept';
export const userSetPhoneUuid = 'user:setphoneuuid';
export const userVerifyPhoneUuid = 'user:verifyphoneuuid';
export const userActivate = 'user:activate';
export const userDisableDeposits = 'user:disabledeposits';
export const userSetRealityCheck = 'user:setrealitycheck';
export const accessBlock = 'access:block';
export const accessUnblock = 'access:unblock';
export const accessConfirmUnblock = 'access:confirmunblock';
export const useForgotPassword = 'user:forgotpassword';
export const userResetPassword = 'user:resetpassword';
export const userDefaultStake = 'user:defaultstake';
export const userOddsType = 'user:oddstype';
export const userGetMarketingPreferences = 'user:getmarketingpreferences';
export const userSetMarketingPreferences = 'user:setmarketingpreferences';
export const userRealityResponse = 'user:realityresponse';
export const sessionLogout = 'session:logout';
export const userLogReferral = 'user:logreferral';
export const userConfirmAccountClosure = 'user:confirmaccountclosure';
export const userUpdatePassword = 'user:updatepassword';
export const userGetReferralUrl = 'user:getreferralurl';
export const obsGetMoodbarScore = 'obs:getmoodbarscore';
export const limitSet = 'limit:set';
export const limitGet = 'limit:get';
export const userEnableDeposits = 'user:enabledeposits';
export const sessionRenew = 'session:renew';
export const userAcknowledgeDepositInformation = 'user:acknowledgedepositinformation';
export const userRegistrationUserPath = 'user:registrationUserPath';
export const documentsGetDocsOverview = 'documents:getdocsoverview';
export const userGetPendingQuestions = 'user:questions:getpending';
export const userSubmitQuestionsAnswers = 'user:questions:submit';
export const userZendeskAuthenticate = 'user:zendeskAuthenticate';
export const personalStatsGet = 'personalStats:get';
